// components/layout/MainLayout.js
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { FaBell } from "react-icons/fa";
import BottomNav from "./BottomNav";
import { Link } from "react-router-dom";

const MainLayout = ({ children, activeNavItem }) => {
  const { user } = useContext(AuthContext);

  // Extract first name from full_name or use the actual user data
  const getUserDisplayName = () => {
    if (user?.full_name) {
      // Get first name from full name
      const firstName = user.full_name.split(' ')[0];
      return firstName;
    }
    return user?.name || "Member";
  };

  const getUserAvatar = () => {
    return user?.avatar || "/assets/user.png";
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Navbar */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px",
          background: "#fff",
          borderBottom: "1px solid #eee",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: "18px" }}>
            Welcome back,{" "}
            <span style={{ color: "#0077ff", fontWeight: 600 }}>
              {getUserDisplayName()}
            </span>{" "}
          </h2>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "15px", marginRight: "20px", paddingTop: "15px" }}>
          {/* 🔔 Bell → Link to Notification Page */}
          {/* <Link to="/notifications" style={{ position: "relative", cursor: "pointer", marginRight: "20px" }}>
            <FaBell size={20} />
            <span
              style={{
                position: "absolute",
                top: "-5px",
                right: "-8px",
                background: "red",
                color: "#fff",
                fontSize: "10px",
                borderRadius: "50%",
                padding: "2px 5px",
              }}
            >
              2
            </span>
          </Link> */}

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Link to="/profile">
              <img
                src={getUserAvatar()}
                alt="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </Link>
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main style={{ flex: 1, padding: "20px", background: "#f9f9f9", paddingBottom: "80px" }}>
        {children}
      </main>

      {/* Bottom Navigation */}
      <BottomNav activeItem={activeNavItem} />
    </div>
  );
};

export default MainLayout;